import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <div className="flex h-screen items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-300">۴۰۴</h1>
      <p className="mt-4">صفحه مورد نظر یافت نشد .</p>
      <Link to="/">
        <button
          type="button"
          className="mt-6 rounded bg-brand px-6 py-2 text-sm font-semibold text-white transition hover:bg-brand-dark"
        >
          برو به صفحه اصلی
        </button>
      </Link>
    </div>
  </div>
);

export default NotFoundPage;
